import { Link } from 'react-router-dom';

import { ReactComponent as FavoritesIcon } from 'assets/icons/favorites-nav.svg';
import { messages, detectPreferredLocale } from '@inscore/shared';

const locale = detectPreferredLocale();
const msg = (k) =>
    (messages[locale] && messages[locale][k]) || messages.en[k] || k;

export const burgerMenuItems = [
    {
        key: 'favorites',
        label: (
            <Link
                to="/favorites"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                }}
            >
                <FavoritesIcon
                    style={{ width: 24, height: 24 }}
                    className="stroke-base"
                />
                {msg('favorites')}
            </Link>
        ),
    },
];
